import { render, staticRenderFns } from "./CreateRaces.vue?vue&type=template&id=3c3fb9fb&"
import script from "./CreateRaces.vue?vue&type=script&lang=js&"
export * from "./CreateRaces.vue?vue&type=script&lang=js&"
import style0 from "./CreateRaces.vue?vue&type=style&index=0&id=3c3fb9fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports